export default __webpack_public_path__ + "static/media/kp.24c2b809.svg";